export const OPEN_GUIDE = "@CUSTOM/GUIDE/OPEN_GUIDE";
